import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom"; // Import useLocation
// Common
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";

// Auth
import Login from "./components/auth/Login";
import Logout from "./components/auth/Logout";

// Public
import Home from "./components/public/Home"; // Import Home for visitors

// User Panel
import Sidebar from "./components/user/Sidebar";
import Dashboard from "./components/user/Dashboard";
import Users from "./components/user/Users";
import Events from "./components/user/Events";
import EventDetail from "./components/user/EventDetail";
import EventForm from "./components/user/EventForm";
import Moderate from "./components/user/Moderate";
import Ads from "./components/user/Ads";
import AdsGroup from "./components/user/AdsGroup";
import Scripts from "./components/user/Scripts";
import AccountSettings from "./components/user/AccountSettings";

import "./App.css";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [role, setRole] = useState(""); // State to store user role
  const location = useLocation(); // Now works correctly inside Router context


  useEffect(() => {
    const accessTokenCheck = localStorage.getItem("accessToken");
    setRole(localStorage.getItem("role"));
    if (accessTokenCheck) {
      setIsLoggedIn(true);
    }
  }, []);

  // Determine if the current route is "event/:eventUrlSlug"
  const isEventDetailPage = location.pathname.startsWith("/event/");
  const isEventFormPage = location.pathname.startsWith("/event-form/");

  // console.log({ role });

  return (
    <div className="App wrapper">
      {/* Conditionally render Sidebar based on login and role */}

      {isLoggedIn &&
        !isEventDetailPage && // Exclude Sidebar on EventDetail page
        !isEventFormPage && <Sidebar />}

      <div
        className={
          isLoggedIn && !isEventDetailPage && !isEventFormPage
            ? "main-panel"
            : ""
        }
      >
        {/* Conditionally render Header */}
        {isLoggedIn && !isEventDetailPage && !isEventFormPage && <Header />}

        {/* Routes */}
        <Routes>
          {/* Landing page for visitors */}

          <Route
            path="/"
            element={
              isLoggedIn ? <Navigate to={"/user/dashboard"} /> : <Home />
            }
          />

          {/* {role != "admin" && (
            <Route
              path="/"
              element={
                isLoggedIn ? <Navigate to={"/user/moderate"} /> : <Home />
              }
            />
          )} */}

          <Route
            path="/login"
            element={<Login setIsLoggedIn={setIsLoggedIn} />}
          />
          <Route path="/logout" element={<Logout />} />

          {/* User routes */}

          <Route
            path="/user/dashboard"
            element={isLoggedIn ? <Dashboard /> : <Navigate to="/" />}
          />

          <Route
            path="/user/users"
            element={
              isLoggedIn ? (
                <Users />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          <Route
            path="/user/events"
            element={
              isLoggedIn ? (
                <Events />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          <Route
            path="/user/ads"
            element={
              isLoggedIn ? (
                <Ads />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          <Route
            path="/user/ads-group"
            element={
              isLoggedIn ? (
                <AdsGroup />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          <Route
            path="/user/scripts"
            element={
              isLoggedIn ? (
                <Scripts />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          <Route
            path="/user/account-settings"
            element={
              isLoggedIn ? (
                <AccountSettings />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          <Route
            path="/user/moderate"
            element={
              isLoggedIn ? (
                <Moderate />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          <Route path="/event/:eventUrlSlug" element={<EventDetail />} />
          <Route path="/event-form/:eventUrlSlug" element={<EventForm />} />

          {/* Catch-all route to redirect to landing page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        {/* Conditionally render Footer */}
        {isLoggedIn && !isEventDetailPage && !isEventFormPage && <Footer />}
      </div>
    </div>
  );
}

export default App;
